module.exports = __webpack_public_path__ + "img/ImgnApoloFull.7d3e0ce5.png";